export const theme = {
    colors: {
      primaryColor: "teal",
      textColor: "rgb(26, 26, 26)",
      backgroundColor: "rgb(255, 255, 255)"
    },
    breakpoints: {
      mobile: 767
    }
  }